module.exports = __webpack_public_path__ + "img/login_tab03_02.4f0721ca.png";